import Layout from "@/pages/layouts/application"
import VoiceNoteWidget from "@/components/audio/voice_note_widget"
import { PageHeader } from "@/components/core/page_header"

export default function Show() {
  return (
    <Layout>
      <PageHeader
        title="Say hello to Lucy."
        description="Lucy is your AI content strategist. Her job is to help you flesh out your uncooked thoughts and ideas into compelling content.">
      </PageHeader>

      <div className="w-full flex-grow">
        <VoiceNoteWidget />
      </div>
    </Layout>
  )
}
